var _path, _path2, _path3, _path4, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorLounge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.691,16.865v7.099H7.309v-7.099h-1.947c-1.305,0-2.363,1.058-2.363,2.363v9.71h36.002v-9.71c0-1.305-1.058-2.363-2.363-2.363h-1.947Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.618,9.766c-1.827,0-3.309,1.481-3.309,3.309v10.889h27.382v-10.889c0-1.827-1.481-3.309-3.309-3.309H10.618Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.47,19.129h10.31c1.689,0,3.06,1.371,3.06,3.06v1.775H7.47v-4.835h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m21.16,19.129h13.37v1.775c0,1.689-1.371,3.06-3.06,3.06h-10.31v-4.835h0Z",
    transform: "translate(55.691 43.093) rotate(-180)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "8.007 32.234 5.471 32.234 5.471 28.938 9.4 28.938 8.007 32.234"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "33.993 32.234 36.529 32.234 36.529 28.938 32.6 28.938 33.993 32.234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorLounge);
export default __webpack_public_path__ + "static/media/indoor-lounge.0c0aa1ef500633aad0f2956d91422d6e.svg";
export { ForwardRef as ReactComponent };